package com.fantasytenis.shared.domain.notifications.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.domain.notifications.NotificationsRepository
import com.fantasytenis.shared.domain.notifications.entity.NotificationPage

/**
 * Use case for fetching user notifications.
 * Updates SharedData with the fetched notifications.
 */
class GetNotificationsUseCase(
    private val repository: NotificationsRepository
) {
    /**
     * Fetch notifications and update SharedData.
     *
     * @param limit Number of notifications to fetch
     * @param offset Pagination offset
     * @param unreadOnly Whether to fetch only unread notifications
     * @param appendToExisting Whether to append to existing notifications (for pagination)
     */
    suspend operator fun invoke(
        limit: Int = 20,
        offset: Int = 0,
        unreadOnly: Boolean = false,
        appendToExisting: Boolean = false
    ): Result<NotificationPage> = runCatching {
        val page = repository.getNotifications(limit, offset, unreadOnly)

        // Update SharedData
        if (appendToExisting && offset > 0) {
            // Append to existing list (pagination)
            val current = SharedData.notifications.value
            SharedData.notifications.value = current + page.notifications
        } else {
            // Replace list
            SharedData.notifications.value = page.notifications
        }

        page
    }
}
